import state from './state'
import actions from './actions'
import getters from './getters'
import modules from './modules'
import mutations from './mutations'

export default {
  namespaced: true,
  state,
  actions,
  getters,
  modules,
  mutations
}